<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { classNames } from '@components/utils';

import { makeInvertColor, makeThemeProps, provideTheme, useInvertColor, useRender } from '../../composable';

import type { PropType } from 'vue';

export const componentName = 'CdsBadge';
export default defineComponent({
  name: componentName,
  props: {
    /**
     * Число для счетчика
     */
    count: {
      type: [Number, String] as PropType<number | string | undefined>,
      // todo: разобраться с тестами (без дефолта ошибка)
      default: undefined
    },
    /**
     * Ограничение счетчика до 99+
     */
    limited: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    ...makeInvertColor(),
    ...makeThemeProps()
  },
  setup(props) {
    const { themeClasses } = provideTheme(props);
    const { invertColorClasses } = useInvertColor(props, componentName);

    const limitedClasses = computed(() => ({
      'cds-badge--limited': props.limited
    }));

    const adjustedCount = computed(() => {
      if (props.count === undefined) return;
      if (props.limited) {
        const count = +props.count;
        return count < 99 && count > -99 ? count : count < -99 ? '-99' : '99+';
      } else {
        return props.count;
      }
    });

    useRender(() =>
      h(
        'span',
        {
          class: classNames('cds-badge', unref(invertColorClasses), unref(themeClasses), unref(limitedClasses))
        },
        unref(adjustedCount)
      )
    );

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsBadge';
</style>
